import axios from 'axios';
import { getApiUrl } from '@utils/getApiUrl';

export const instance = axios.create({
  withCredentials: true,
  baseURL: getApiUrl(),
});
